import { ResponseDataGet } from "../../../../models/responseDataGet";
import { ResponseDataTest } from "../../../../models/responseDataTest";
import { agroApi } from "../../api";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import { BasicHbFilter } from "../../../../models/filters/basicHbFilter";
import { Paths } from "../../../../paths";

export const typesOfAgriculturalCropsApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getTypesOfAgriculturalCropsList: builder.query<ResponseDataGet<EntDirectoryInfoName>, BasicHbFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.typesOfAgriculturalCrops }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getTypesOfAgriculturalCropsById: builder.query<ResponseDataTest<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.typesOfAgriculturalCrops }/${ id }`,
		method: 'GET'
	  })
	}),
	addTypesOfAgriculturalCrops: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body) => ({
		url: `${ Paths.handbooks.typesOfAgriculturalCrops }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editTypesOfAgriculturalCrops: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.typesOfAgriculturalCrops }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteTypesOfAgriculturalCrops: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.typesOfAgriculturalCrops }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetTypesOfAgriculturalCropsListQuery,
  useAddTypesOfAgriculturalCropsMutation,
  useEditTypesOfAgriculturalCropsMutation,
  useDeleteTypesOfAgriculturalCropsMutation
} = typesOfAgriculturalCropsApi;
